/** Roles granted SELECT on the PII-free operational calendar projections. */
export const CALENDAR_REALTIME_ROLES = ["hub_manager", "admin", "superadmin"] as const;

/** Hub managers must be scoped by the hub id carried in their verified JWT. */
export function canSubscribeToCalendarRealtime(role: string, hubId: string | null): boolean {
  return role === "admin" || role === "superadmin" || (role === "hub_manager" && !!hubId);
}
